import NoReservations from './NoReservations';
import ReservationRow from './ReservationRow';

const ReservationList = (props) => {
  const { reservations, query, settings } = props;

  if (query.length === 0) {
    return <NoReservations />;
  }
  return (
    <>
      {query.map((resrevationId) => (
        <ReservationRow
          key={resrevationId}
          reservation={reservations[resrevationId]}
          settings={settings}
        />
      ))}
    </>
  );
};

export default ReservationList;
